export const T = {
  sidebar: {
    forms: "sidebar-nav-forms",
    candidates: "sidebar-nav-candidates",
    talentPool: "sidebar-nav-talent-pool",
    referrals: "sidebar-nav-referrals",
    outreach: "sidebar-nav-outreach",
    settings: "sidebar-nav-settings",
    logout: "sidebar-logout",
  },
  login: {
    googleBtn: "login-google-btn",
  },
  forms: {
    newBtn: "forms-new-btn",
    row: (id) => `forms-row-${id}`,
    openBtn: (id) => `forms-open-${id}`,
    responsesBtn: (id) => `forms-responses-${id}`,
    cloneBtn: (id) => `forms-clone-${id}`,
    archiveBtn: (id) => `forms-archive-${id}`,
    publicLink: (id) => `forms-public-link-${id}`,
  },
  builder: {
    saveBtn: "builder-save-btn",
    titleInput: "builder-title-input",
    slugInput: "builder-slug-input",
    addStep: "builder-add-step",
    paletteItem: (kind) => `builder-palette-${kind}`,
    blockRow: (id) => `builder-block-${id}`,
    deleteBlock: (id) => `builder-delete-${id}`,
    insLabel: "builder-inspector-label",
    insRequired: "builder-inspector-required",
    insWeight: "builder-inspector-weight",
    insRubric: "builder-inspector-rubric",
    insOptions: "builder-inspector-options",
    insKnockout: "builder-inspector-knockout",
  },
  responses: {
    kpiViews: "kpi-views",
    kpiCompletion: "kpi-completion",
    kpiMedian: "kpi-median",
    kpiPartials: "kpi-partials",
    kpiBooked: "kpi-booked",
    nudgeBtn: "nudge-partials-btn",
    row: (id) => `submissions-row-${id}`,
  },
  candidates: {
    kanban: "candidates-kanban",
    tableToggle: "candidates-view-table",
    kanbanToggle: "candidates-view-kanban",
    column: (name) => `kanban-column-${name.toLowerCase().replace(/\s+/g, "-")}`,
    card: (id) => `candidate-card-${id}`,
    stageSelect: (id) => `candidate-stage-select-${id}`,
    rescore: (id) => `candidate-rescore-${id}`,
    archive: (id) => `candidate-archive-${id}`,
    noteInput: (id) => `candidate-note-input-${id}`,
    noteSave: (id) => `candidate-note-save-${id}`,
  },
  publicForm: {
    step: (n) => `public-form-step-${n}`,
    input: (id) => `public-form-input-${id}`,
    next: "public-form-next",
    prev: "public-form-prev",
    submit: "public-form-submit",
    slot: (iso) => `public-form-slot-${iso}`,
    day: (date) => `public-form-day-${date}`,
    thankYou: "public-form-thank-you",
    knockout: "public-form-knockout",
  },
};

export default T;
